export default __webpack_public_path__ + "static/media/img_11.9c7abef1.jpg";